import script from "./MakerCartGuide3Page.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCartGuide3Page.vue?vue&type=script&setup=true&lang=js"

import "./MakerCartGuide3Page.vue?vue&type=style&index=0&id=b6969f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6969f30"]])

export default __exports__